import { useState, useRef } from 'react';
import { Phone, Mail, Lock, Apple, ArrowLeft, Loader2, User, X, Eye, EyeOff } from 'lucide-react';

export default function LoginOptionsOverlay({ onClose, onSignInWithGoogle, onSignInWithApple, onSignUpAnonymously, onSignInWithEmail, onSignUpWithEmail, onSendCode, onVerifyCode, busy }) {
  const [mode, setMode] = useState('options'); // 'options' | 'email' | 'signup' | 'phone' | 'code'
  const [err, setErr] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const emailRef = useRef(null);
  const passwordRef = useRef(null);
  const phoneRef = useRef(null);
  const codeRef = useRef(null);

  const isSignup = mode === 'signup';

  const handleEmailSignIn = async () => {
    const email = emailRef.current?.value?.trim();
    const password = passwordRef.current?.value;
    if (!email || !password) return;
    setErr('');
    await onSignInWithEmail(email, password, (error) => setErr(error));
  };

  const handleEmailSignUp = async () => {
    const email = emailRef.current?.value?.trim();
    const password = passwordRef.current?.value;
    if (!email || !password) return;
    setErr('');
    await onSignUpWithEmail(email, password, (error) => setErr(error));
  };

  const handleSendCode = async () => {
    const phone = phoneRef.current?.value?.trim();
    if (!phone) return;
    setErr('');
    await onSendCode(phone, (error) => setErr(error));
    if (!err) setMode('code');
  };

  const handleVerifyCode = async () => {
    const phone = phoneRef.current?.value?.trim();
    const code = codeRef.current?.value?.trim();
    if (!phone || !code) return;
    setErr('');
    await onVerifyCode(phone, code, (error) => setErr(error));
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-foreground/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-sm rounded-3xl bg-card shadow-xl">
        <div className="relative flex items-center justify-center border-b px-5 py-3">
          {mode !== 'options' && (
            <button onClick={() => setMode('options')} className="absolute left-5 flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground">
              <ArrowLeft className="h-4 w-4" />
              Back
            </button>
          )}
          {mode === 'options' && (
            <h2 className="text-lg font-semibold text-foreground">Choose a Method</h2>
          )}
          {mode !== 'options' && (
            <h2 className="text-lg font-semibold text-foreground">{isSignup ? 'Sign up' : 'Sign in'}</h2>
          )}
          <button
            onClick={onClose}
            className="absolute right-5 text-muted-foreground hover:text-foreground"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="space-y-3 p-5">
          {mode === 'options' && (
          <>

            {/* <button disabled={busy} onClick={onSignInWithGoogle} className="flex w-full items-center justify-center gap-2 rounded-full border border-border bg-background py-3 text-sm font-medium hover:bg-muted disabled:opacity-50">
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.6-6 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.3-.4-3.5z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16 19 13 24 13c3 0 5.8 1.1 7.9 3l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.6 8.3 6.3 14.7z"/><path fill="#4CAF50" d="M24 44c5.2 0 10-2 13.6-5.2l-6.3-5.3C29.2 35 26.7 36 24 36c-5.2 0-9.7-3.4-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4 5.5l6.3 5.3C41.6 35.5 44 30.2 44 24c0-1.3-.1-2.3-.4-3.5z"/></svg>}
              Continue with Google
            </button> */}

            {/* <button disabled={busy} onClick={onSignInWithApple} className="flex w-full items-center justify-center gap-2 rounded-full border border-border bg-background py-3 text-sm font-medium hover:bg-muted disabled:opacity-50">
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Apple className="h-4 w-4" />}
              Continue with Apple
            </button> */}

            <button onClick={() => setMode('signup')} className="flex w-full items-center justify-center gap-2 rounded-full border border-border bg-background py-3 text-sm font-medium hover:bg-muted">
              <Mail className="h-4 w-4" />
              Continue with Email
            </button>

            <button disabled={busy} onClick={onSignUpAnonymously} className="flex w-full items-center justify-center gap-2 rounded-full border border-border bg-background py-3 text-sm font-medium hover:bg-muted disabled:opacity-50">
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <User className="h-4 w-4" />}
              Continue Anonymously
            </button>

            {/* <button onClick={() => setMode('phone')} className="flex w-full items-center justify-center gap-2 rounded-full border border-border bg-background py-3 text-sm font-medium hover:bg-muted">
              <Phone className="h-4 w-4" />
              Continue with Phone
            </button> */}
          </>
        )}

        {(mode === 'email' || mode === 'signup') && (
          <>
            <label className="block text-xs font-semibold uppercase tracking-wide text-primary">Email</label>
            <div className="flex items-center gap-2 rounded-full border border-input bg-background px-3 py-2">
              <Mail className="h-4 w-4 text-muted-foreground" />
              <input ref={emailRef} type="email" placeholder="you@example.com" className="flex-1 bg-transparent text-sm focus:outline-none" />
            </div>

            <label className="mt-2 block text-xs font-semibold uppercase tracking-wide text-primary">Password</label>
            <div className="flex items-center gap-2 rounded-full border border-input bg-background px-3 py-2">
              <Lock className="h-4 w-4 text-muted-foreground" />
              <input ref={passwordRef} type={showPassword ? 'text' : 'password'} placeholder="••••••••" className="flex-1 bg-transparent text-sm focus:outline-none" />
              <button type="button" onClick={() => setShowPassword(v => !v)} className="text-muted-foreground hover:text-foreground transition-colors">
                {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
              </button>
            </div>

            <button
              disabled={busy}
              onClick={isSignup ? handleEmailSignUp : handleEmailSignIn}
              className="w-full rounded-full bg-primary py-3 text-sm font-semibold text-primary-foreground disabled:opacity-50"
            >
              {busy ? (isSignup ? 'Creating…' : 'Signing in…') : (isSignup ? 'Create Account' : 'Sign in')}
            </button>

              {isSignup ? (
                <button onClick={() => setMode('email')} className="w-full text-xs text-muted-foreground">
                  Already have an account? <span className="text-primary hover:underline">Sign in</span>
                </button>
              ) : (
                <button onClick={() => setMode('signup')} className="w-full text-xs text-muted-foreground">
                  New here? <span className="text-primary hover:underline">Create account</span>
                </button>
              )}

              {!isSignup && (
                <button className="w-full text-xs text-muted-foreground hover:underline">Forgot password?</button>
              )}
          </>
        )}

        {mode === 'phone' && (
          <>
            <label className="block text-xs font-semibold uppercase tracking-wide text-primary">Phone</label>
            <div className="flex items-center gap-2 rounded-full border border-input bg-background px-3 py-2">
              <Phone className="h-4 w-4 text-muted-foreground" />
              <input ref={phoneRef} placeholder="+1 555 555 5555" className="flex-1 bg-transparent text-sm focus:outline-none" />
            </div>
            <button
              disabled={busy}
              onClick={handleSendCode}
              className="w-full rounded-full bg-primary py-3 text-sm font-semibold text-primary-foreground disabled:opacity-50"
            >
              {busy ? 'Sending…' : 'Send code'}
            </button>
          </>
        )}

        {mode === 'code' && (
          <>
            <label className="block text-xs font-semibold uppercase tracking-wide text-primary">Verification code</label>
            <input
              ref={codeRef}
              placeholder="123456"
              className="w-full rounded-full border border-input bg-background px-4 py-2 text-center text-lg tracking-widest focus:outline-none focus:ring-2 focus:ring-ring"
            />
            <button
              disabled={busy}
              onClick={handleVerifyCode}
              className="w-full rounded-full bg-primary py-3 text-sm font-semibold text-primary-foreground disabled:opacity-50"
            >
              {busy ? 'Verifying…' : 'Verify & sign in'}
            </button>
          </>
        )}

        {err && <p className="text-center text-xs text-destructive">{err}</p>}
        </div>
      </div>
    </div>
  );
}
